import React from "react";
import Services from "../../components/Services/Services";
import Banner from "../../components/Banner/Banner";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import ProductSearch from "../../components/ProductSearch/ProductSearch";
import ContactSection from "../../components/ContactSection/ContactSection";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../seo/seoConstants";
import { ServicesContainer } from "../shared/styledComponents";
import Footer from "../../components/Footer/Footer";
import FooterWhatsAppCta from "../../components/WhatsAppLink/FooterWhatsAppCta";
import HomeHighlights from "../../components/HomeHighlights/HomeHighlights";
import { FOOTER_TAGLINE } from "../shared/constants";

const HomePage: React.FC = () => {
  return (
    <PageLayout>
      <Seo {...PAGE_SEO["/"]} />
      {/* Between them these fill the first screen, so they fold away while a search is running —
          otherwise the results are entirely below the fold and a shopper cannot tell whether
          anything matched. */}
      <HomeHighlights>
        <Banner />
        <ServicesContainer>
          <Services />
        </ServicesContainer>
      </HomeHighlights>
      <ProductSearch />
      <ContactSection />
      {/* The page owns its sticky bar; `ProductSearch` used to render it only because that is
          where the search field lived. */}
      <Footer tagline={FOOTER_TAGLINE}>
        <FooterWhatsAppCta />
      </Footer>
    </PageLayout>
  );
};

export default HomePage;
